export default __webpack_public_path__ + "2e94276068d5ebaa12e252ed9c120ae4.svg";